import { ScreenReaderHeader } from '@components/screen-reader/screen-reader-element';
import { DetailsList, type DetailsListProps } from '@eika/details-list';
import type { ReactNode } from 'react';
import './process-details.scss';
import { useTranslation } from '@translations';

interface ProcessDetailsProps extends React.ComponentPropsWithoutRef<'div'> {
    isLoading?: boolean;
    skeletonCount?: number;
    withTitle?: boolean;
    children?: ReactNode;
}

export const ProcessDetails = ({
    children,
    isLoading = false,
    skeletonCount,
    withTitle = false,
    ...props
}: ProcessDetailsProps) => (
    <div {...props} className={`process-details ${props.className ?? ''}`.trim()}>
        <Header withTitle={withTitle} />
        <Body isLoading={isLoading} skeletonCount={skeletonCount}>
            {children}
        </Body>
    </div>
);

const Header = ({ withTitle }: { withTitle: boolean }) => {
    const { processDetails } = useTranslation();

    if (withTitle) {
        return <h3>{processDetails.header}</h3>;
    }

    return <ScreenReaderHeader text={processDetails.headerAria} headerTag="h3" />;
};

const Body = ({
    isLoading,
    skeletonCount,
    children,
}: {
    isLoading?: boolean;
    skeletonCount?: number;
    children: ReactNode;
}) => {
    if (isLoading) {
        return <DetailsList isLoading skeletonCount={skeletonCount} />;
    }

    return <div className="process-details__sections">{children}</div>;
};

type SectionProps = DetailsListProps;

const Section = ({ children, ...props }: SectionProps) => (
    <DetailsList {...props} className="process-details__list" titleClassName="typography-h3">
        {children}
    </DetailsList>
);

ProcessDetails.Section = Section;
